module.exports = __webpack_public_path__ + "img/service_350x500_2.bb852c43.jpg";